'use client';

import { FC } from 'react';
import { CatButton } from 'components/blocks-components';
import { useTranslations } from 'next-intl';
import styles from './will-it-fit.module.scss';
import { useMyEquipmentDrawer } from 'components/my-equipment/my-equipment-drawer-context';
import { SelectedEquipmentInfo } from 'app/[lang]/[esite]/(core)/_header/components/equipment-widget/types';
import { MyEquipmentList } from 'components/my-equipment/types';

interface WillItFitProps {
  selectedEquipmentIndex: number;
  myEquipmentList: MyEquipmentList[];
  selectedEquipmentInfo: SelectedEquipmentInfo;
}
const WillItFit: FC<WillItFitProps> = ({
  selectedEquipmentIndex,
  myEquipmentList,
  selectedEquipmentInfo
}) => {
  const t = useTranslations();
  const buttonTitle = t('MEQ_FITEMENT_COMPONENT_CTA1');
  const {
    addEquipmentDrawer,
    editEquipmentDrawer,
    selectEquipmentDrawer,
    setLastActiveElement
  } = useMyEquipmentDrawer();

  const message = () => {
    if (selectedEquipmentIndex === -1 && myEquipmentList == null) {
      setLastActiveElement(`[data-testid='will-it-fit-btn']`);
      return {
        message: t('MEQ_PDP_FITMENT_CTA3'),
        openclick: addEquipmentDrawer?.openDrawer
      }; //Add your equipment to see if this part fits.
    } else if (
      selectedEquipmentIndex === -1 &&
      Object.keys(selectedEquipmentInfo).length === 0
    ) {
      return {
        message: t('MEQ_PDP_FITMENT_CTA2'),
        openclick: selectEquipmentDrawer?.openDrawer
      }; //Select equipment from your list to see if this part fits
    } else if (
      myEquipmentList.length > 0 &&
      selectedEquipmentInfo.serialNumber === ''
    ) {
      return {
        message: t('MEQ_FITEMENT_COMPONENT_CTA2'),
        openclick: editEquipmentDrawer?.openDrawer
      }; //Add your serial number to see if this part
    } else {
      return null;
    }
  };

  return (
    <CatButton
      variant="ghost"
      className={`pt-2 pb-2 ${styles['will-it-fit__btn']}`}
      title={buttonTitle}
      onClick={message()?.openclick}
      data-testid="will-it-fit-btn"
    >
      <span
        className={`cat-u-theme-typography-label-lg cat-u-display-block text-start ${styles['will-it-fit__link-title']}`}
      >
        {buttonTitle}
      </span>
      <span
        className={`cat-u-theme-typography-footnote text-start ${styles['will-it-fit__link-message']}`}
      >
        {message()?.message}
      </span>
    </CatButton>
  );
};

export default WillItFit;
